import React, { useState, useEffect, createContext, useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";

import Dashboard from "./component/Dashboard";
import ReportHistory from "./component/reportComponents/MainPage/ReportHistory";
import ProfilesManager from "./component/ProfilesManager";
import AiTargets from "./component/targets/AiTargets";
import UserManagement from "./component/UserManagement";
import Generate from "./component/Generate";
import ExampleTrainingPrompts from "./component/ExampleTrainingPrompts";
import HelpPdf from "./component/helpPdf/HelpPdf";
import ExternalApi from "./component/ExternalApiHelp/ExternalApi";
import Help from "./component/help/Help";
import HelpStart from "./component/help/HelpStart";
import HelpLogin from "./component/help/HelpLogin";
import Helpmcpinput from "./component/help/Helpmcpinput";
import HelpAiEndpoint from "./component/help/HelpAiEndpoint";
import HelpCreatePromptsDocs from "./component/help/HelpCreatePromptsDocs";
import Helppromptinput from "./component/help/Helppromptinput";
import Helpdosinput from "./component/help/Helpdosinput";
import Helprtoinput from "./component/help/Helprtoinput";
import Helpgh from "./component/help/Helpgh";
import Helpgl from "./component/help/Helpgl";
import EppromptDoc from "./component/help/EppromptDoc";
import Epvpd from "./component/help/Epvpd";
import Epmvpd from "./component/help/Epmvpd";
import Eprc from "./component/help/Eprc";
import Eprto from "./component/help/Eprto";
import Epsdos from "./component/help/Epsdos";
import Epvdos from "./component/help/Epvdos";
import Epmvdos from "./component/help/Epmvdos";
import Epsmcp from "./component/help/Epsmcp";
import Epvmcp from "./component/help/Epvmcp";
import Epmvmcp from "./component/help/Epmvmcp";
import Llmapi from "./component/help/Llmapi";
import Whlic from "./component/help/Whlic";
import HelpHarness from "./component/help/HelpHarness";

















import HelpProfile from "./component/help/HelpProfile";
import HelpCenter from "./component/help/HelpCenter";
import HelpScan from "./component/help/HelpScan";
import HelpAddUsers from "./component/help/HelpAddUsers";
import Login from "./component/Login";
import Signup from "./component/Signup";
import ForgotPassword from "./component/ForgotPassword";
import ResetPassword from "./component/ResetPassword";
import VerifyEmail from "./component/VerifyEmail";
import TestStatus from "./component/testStatus/TestStatus";
import Account from "./component/Account";
import QuickStart from "./component/QuickStart";
import AisprawlLayout from "./component/aisprawl/AisprawlLayout";
import AisprawlDashboard from "./component/aisprawl/AisprawlDashboard";
import AisprawlScan from "./component/aisprawl/AisprawlScan";
import AisprawlReports from "./component/aisprawl/AisprawlReports";
import AisprawlConfig from "./component/aisprawl/AisprawlConfig";
import AisprawlUsers from "./component/aisprawl/AisprawlUsers";
import AisprawlSystem from "./component/aisprawl/AisprawlSystem";
import AisprawlHelp from "./component/aisprawl/AisprawlHelp";
import MsspDashboard from "./component/mssp/MsspDashboard";
import AIEndpoint from "./component/help/AIEndpoint";
import AIEndpointOverview from "./component/help/AIEndpointOverview";
import ConfigureAIEndpoint from "./component/help/ConfigureAIEndpoint";
import TestAIEndpoint from "./component/help/TestAIEndpoint";
import HelpSubscreenTemplate from "./component/help/HelpSubscreenTemplate";
import Helpprompt from "./component/help/Helpprompt";
import Helpdos from "./component/help/Helpdos";
import Helpmcp from "./component/help/Helpmcp";
import Helpmodelattack from "./component/help/Helpmodelattack";
import Helprto from "./component/help/Helprto";
import Helprgp from "./component/help/Helprgp";
import Helprgprofile from "./component/help/Helprgprofile";
import CreateEp from "./component/help/CreateEp";
import Helprginput from "./component/help/Helprginput";
import Helpins from "./component/help/Helpins";
import GetEndpointById from "./component/help/GetEndpointById";
import GetAllEndpoints from "./component/help/GetAllEndpoints";
import DeleteEndpoint from "./component/help/DeleteEndpoint";
import CreateEndpointUsingScripts from "./component/help/CreateEndpointUsingScripts";
import Helpcus from "./component/help/Helpcus";
import CreateEndpointUsingJsonParams from "./component/help/CreateEndpointUsingJsonParams";
import GetAllTests from "./component/help/GetAllTests";
import GetTestStatusById from "./component/help/GetTestStatusById";
import RunTest from "./component/help/RunTest";
import StopTest from "./component/help/StopTest";
import HaCreateProfile from "./component/help/HaCreateProfile";
import HaGetProfileById from "./component/help/HaGetProfileById";
import HaGetAllProfiles from "./component/help/HaGetAllProfiles";
import HaDeleteProfile from "./component/help/HaDeleteProfile";
import Hconsolidated from "./component/help/Hconsolidated";
import HaGetReportById from "./component/help/HaGetReportById";
import HaGetAllTestFiles from "./component/help/HaGetAllTestFiles";
import HaProfileConfig from "./component/help/HaProfileConfig";
import HaProfileConfigAISpecific from "./component/help/HaProfileConfigAISpecific";
import HaProfileConfigMCP from "./component/help/HaProfileConfigMCP";
import HaProfileConfigPDocs from "./component/help/HaProfileConfigPDocs";
import HaProfileConfigRTO from "./component/help/HaProfileConfigRTO";
import HaProfileConfigReg from "./component/help/HaProfileConfigReg";
import HaGetSessionKey from "./component/help/HaGetSessionKey";
import DownloadEndpointFiles from "./component/help/DownloadEndpointFiles";
import Helppdf from "./component/help/Helppdf";
import HaGetRecommendations from "./component/help/HaGetRecommendations";
import Llmprofile from "./component/help/Llmprofile";
import AISimulatorGuide from "./component/help/AISimulatorGuide";



































import "./styles/theme.css";
import "./styles/dashboard.css";
import { checkAuth } from "./utils/apiHelper";
import { UserProvider } from "./contexts/UserContext";

// Create context for sidebar state
const SidebarContext = createContext();

// Custom hook to use sidebar context
export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

// Protected Route Component
function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const authResult = await checkAuth();
        setIsAuthenticated(authResult.authenticated);
      } catch (error) {
        // Only log in development
        if (process.env.NODE_ENV === 'development') {
          console.error('Auth check error:', error);
        }
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    verifyAuth();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
}

// Public Route Component (redirect to dashboard if already logged in)
function PublicRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const authResult = await checkAuth();
        setIsAuthenticated(authResult.authenticated);
      } catch (error) {
        // Only log in development
        if (process.env.NODE_ENV === 'development') {
          console.error('Auth check error:', error);
        }
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    verifyAuth();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return isAuthenticated ? <Navigate to="/" /> : children;
}

function ThemeToggle({ darkMode, setDarkMode }) {
  const { pathname } = useLocation();
  if (pathname.startsWith("/mssp")) return null;

  return (
    <button
      onClick={() => setDarkMode(!darkMode)}
      style={{
        position: "fixed",
        top: "15px",
        right: "20px",
        zIndex: 9999,
        padding: "8px 12px",
        borderRadius: "20px",
        border: "none",
        backgroundColor: darkMode ? "#334155" : "#e2e8f0",
        color: darkMode ? "#f1f5f9" : "#1e293b",
        cursor: "pointer",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        transition: "all 0.3s ease",
      }}
    >
      {darkMode ? "☀️ Light Mode" : "🌙 Dark Mode"}
    </button>
  );
}

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    // Default to dark mode (true) unless explicitly set to "light"
    return savedTheme !== "light";
  });
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    localStorage.getItem("sidebarCollapsed") === "true"
  );

  // Apply theme on mount and toggle
  useEffect(() => {
    document.body.setAttribute("data-theme", darkMode ? "dark" : "light");
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  // Save sidebar state to localStorage
  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", sidebarCollapsed.toString());
  }, [sidebarCollapsed]);

  // Note: Removed automatic auth cleanup to allow session persistence across page refreshes
  // Authentication will still expire based on the expiresAt timestamp in localStorage

  return (
    <SidebarContext.Provider value={{ sidebarCollapsed, setSidebarCollapsed }}>
      <UserProvider>
      <Router>
        <ThemeToggle darkMode={darkMode} setDarkMode={setDarkMode} />

        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />
          <Route path="/signup" element={
            <PublicRoute>
              <Signup />
            </PublicRoute>
          } />
          <Route path="/forgot-password" element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          } />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/reports" element={
            <ProtectedRoute>
              <ReportHistory />
            </ProtectedRoute>
          } />

          <Route path="/profiles" element={
            <ProtectedRoute>
              <ProfilesManager />
            </ProtectedRoute>
          } />
          <Route path="/targets" element={
            <ProtectedRoute>
              <AiTargets />
            </ProtectedRoute>
          } />
          <Route path="/employees" element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          } />
          <Route path="/generate" element={
            <ProtectedRoute>
              <Generate />
            </ProtectedRoute>
          } />
          <Route path="/example-training-prompts" element={
            <ProtectedRoute>
              <ExampleTrainingPrompts />
            </ProtectedRoute>
          } />
          <Route path="/help/pdf" element={
            <ProtectedRoute>
              <HelpPdf />
            </ProtectedRoute>
          } />
          
         
         
         

         












          
          

          <Route path="/help/helpcenter" element={
            <ProtectedRoute>
              <HelpCenter />
            </ProtectedRoute>
          } />


           <Route path="/status" element={
            <ProtectedRoute>
              <TestStatus />
            </ProtectedRoute>
          } />
          <Route path="/account" element={
            <ProtectedRoute>
              <Account />
            </ProtectedRoute>
          } />
          <Route path="/quick-start" element={
            <ProtectedRoute>
              <QuickStart />
            </ProtectedRoute>
          } />

          {/* Help section - protected */}
          <Route path="/help" element={
            <ProtectedRoute>
              <Help />
            </ProtectedRoute>
          }>
            <Route path="help-subscreen-template" element={<HelpSubscreenTemplate />} />
             <Route path="login" element={ <HelpLogin />  } />
             <Route path="start" element={<HelpStart />  } />
             <Route path="ai-endpoint" element={<AIEndpoint />} />
          <Route path="ai-endpoint/overview" element={<AIEndpointOverview />} />
            <Route path="endpoint1" element={<CreateEp />} />




          <Route path="ai-endpoint/configure" element={<ConfigureAIEndpoint />} />
          <Route path="ai-endpoint/test" element={<TestAIEndpoint />} />
          <Route path="mcp-profile" element={<Helpmcp />} />
<Route path="instructions" element={<Helpins />} />
<Route path="getelement" element={<GetEndpointById />} />
<Route path="getallep" element={<GetAllEndpoints />} />
<Route path="deleteep" element={<DeleteEndpoint />} />






          <Route path="dos-profile" element={<Helpdos />} />
          <Route path="model-attack-profile" element={<Helpmodelattack />} />
          <Route path="prompt-profile" element={<Helpprompt />} />
          <Route path="rto-profile" element={<Helprto />} />
<Route path="mcpinput" element={<Helpmcpinput />} />
<Route path="prinput" element={<Helppromptinput />} />
<Route path="hdosinput" element={<Helpdosinput />} />
<Route path="hrtosinput" element={<Helprtoinput />} />
<Route path="helprgp" element={<Helprgp />} />
<Route path="helprgprofile" element={<Helprgprofile />} />
<Route path="helpreginput" element={<Helprginput />} />
<Route path="helpgh" element={<Helpgh />} />
<Route path="helpgl" element={<Helpgl />} />
<Route path="epscript" element={<CreateEndpointUsingScripts />} />
<Route path="cus" element={<Helpcus />} />
<Route path="usingParam" element={<CreateEndpointUsingJsonParams />} />
<Route path="getalltests" element={<GetAllTests />} />
<Route path="testid" element={<GetTestStatusById />} />
<Route path="runtest" element={<RunTest />} />
<Route path="stoptest" element={<StopTest />} />
<Route path="apiCp" element={<HaCreateProfile />} />
<Route path="profileByid" element={<HaGetProfileById />} />
<Route path="allProfiles" element={<HaGetAllProfiles />} />
<Route path="delprofile" element={<HaDeleteProfile />} />
<Route path="con-reports" element={<Hconsolidated />} />
<Route path="reportByid" element={<HaGetReportById />} />
<Route path="alltestfiles" element={<HaGetAllTestFiles />} />
<Route path="profileconfig" element={<HaProfileConfig />} />
<Route path="profileconfigai" element={<HaProfileConfigAISpecific />} />
<Route path="profileconfigmcp" element={<HaProfileConfigMCP />} />
<Route path="profileconfigpd" element={<HaProfileConfigPDocs />} />
<Route path="profileconfigrto" element={<HaProfileConfigRTO />} />
<Route path="profileconfigreg" element={<HaProfileConfigReg />} />
<Route path="getsessionkey" element={<HaGetSessionKey />} />
<Route path="downloadep" element={<DownloadEndpointFiles />} />
<Route path="pdfgen" element={<Helppdf />} />
<Route path="recapi" element={<HaGetRecommendations />} />



<Route path="eppromptDoc" element={<EppromptDoc />} />
<Route path="epvpd" element={<Epvpd />} />
<Route path="epmvpd" element={<Epmvpd />} />
<Route path="eprc" element={<Eprc />} />
<Route path="eprto" element={<Eprto />} />
<Route path="epsdos" element={<Epsdos />} />
<Route path="epvdos" element={<Epvdos />} />
<Route path="epmvdos" element={<Epmvdos />} />
<Route path="epsmcp" element={<Epsmcp />} />
<Route path="epvmcp" element={<Epvmcp />} />
<Route path="epmvmcp" element={<Epmvmcp />} />
<Route path="llmapi" element={<Llmapi />} />
<Route path="lic" element={<Whlic />} />
<Route path="helpHarness" element={<HelpHarness />} />



























































<Route path="create-prompts-docs" element={       <HelpCreatePromptsDocs /> } />
<Route path="llmprofile" element={       <Llmprofile /> } />
<Route path="ai-sim-guide" element={       <AISimulatorGuide /> } />







<Route path="scan" element={<HelpScan />
           
          } />
<Route path="profile" element={      <HelpProfile /> } />
<Route path="external-api-testing" element={  <ExternalApi />} />


           <Route path="ai-endpoint" element={<HelpAiEndpoint />} />
          <Route path="add-users" element={          
              <HelpAddUsers />
           
          } />
         

          </Route>

          {/* AISprawl section - protected, own sidebar */}
          <Route path="/aisprawl" element={
            <ProtectedRoute>
              <AisprawlLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/aisprawl/dashboard" replace />} />
            <Route path="dashboard" element={<AisprawlDashboard />} />
            <Route path="scan" element={<AisprawlScan />} />
            <Route path="reports" element={<AisprawlReports />} />
            <Route path="config" element={<AisprawlConfig />} />
            <Route path="users" element={<AisprawlUsers />} />
            <Route path="system" element={<AisprawlSystem />} />
            <Route path="help" element={<AisprawlHelp />} />
          </Route>

          {/* MSSP section - protected, mock-backed (same pattern as aisprawl) */}
          <Route path="/mssp/*" element={
            <ProtectedRoute>
              <MsspDashboard />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
      </UserProvider>
    </SidebarContext.Provider>
  );
}

export default App;
